import { render, staticRenderFns } from "./BrandProductItem.vue?vue&type=template&id=9dc8fce2&lang=pug"
import script from "./BrandProductItem.vue?vue&type=script&lang=js"
export * from "./BrandProductItem.vue?vue&type=script&lang=js"
import style0 from "./BrandProductItem.vue?vue&type=style&index=0&id=9dc8fce2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports